import type { CarouselState } from '#/components/Carousel/CarouselState';
import { DotNavigationButton } from '#/components/DotNavigationButton/DotNavigationButton';
import { Icon } from '#/components/Icon/Icon';
import { LegacyButton } from '#/components/LegacyButton/LegacyButton';
import { useI18n } from '#/i18n/hooks/useI18n';
import { range } from '#/utils/functional/array/range';

import {
  CmsThreeSectionSliderBlockCarouselNavigationDots,
  CmsThreeSectionSliderBlockCarouselNavigationHolder,
} from './CmsThreeSectionSliderBlockCarouselNavigation.styled';

type Props = {
  carouselState: CarouselState;
};

export function CmsThreeSectionSliderBlockCarouselNavigation({
  carouselState,
}: Props) {
  const { i18n } = useI18n();

  const { currentPage, pageCount, goToNextPage, goToPreviousPage, goToPage } =
    carouselState;

  const title = {
    prev: i18n('Previous page'),
    next: i18n('Next page'),
  };
  const prevDisabled = currentPage <= 0;
  const nextDisabled = currentPage >= pageCount - 1;

  if (pageCount === 0) return null;

  return (
    <nav>
      <CmsThreeSectionSliderBlockCarouselNavigationHolder>
        <LegacyButton
          onClick={goToPreviousPage}
          aria-label={title.prev}
          title={title.prev}
          disabled={prevDisabled}
          qaId="carousel-left-button"
        >
          <Icon name="chevron-left" size={24} />
        </LegacyButton>

        <LegacyButton
          onClick={goToNextPage}
          aria-label={title.next}
          title={title.next}
          disabled={nextDisabled}
          qaId="carousel-right-button"
        >
          <Icon name="chevron-right" size={24} />
        </LegacyButton>
      </CmsThreeSectionSliderBlockCarouselNavigationHolder>

      <CmsThreeSectionSliderBlockCarouselNavigationDots>
        {range(pageCount).map((index) => (
          <DotNavigationButton
            key={index}
            onClick={() => goToPage(index)}
            $isActive={index === currentPage}
            title={`${i18n('Go to page')} ${index + 1}`}
          />
        ))}
      </CmsThreeSectionSliderBlockCarouselNavigationDots>
    </nav>
  );
}
